import Vue from 'vue';

/**
 * 加载常用路线的模块回调
 * @param path
 * @returns {function(): Promise<*>}
 */
const loadRouteComponent = (path) => () => import(/* webpackChunkName: "route" */ `@/pages/${path}`).then((module) => {
  try {
    Vue.prototype.$customEventWithPointId({
      pointId: `h5-load-${path}-success`,
    });
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return module;
}).catch((error) => {
  Vue.prototype.$customEventWithPointId({
    pointId: `h5-load-${path}-error`,
    businessInfo: {
      error,
    },
  });
});

const routes = [{
  path: '/follow-public',
  name: 'follow-public',
  meta: { title: '开通微信通知服务', label: '开通微信通知服务' },
  component: () => import(/* webpackChunkName: "follow-public" */ '@/pages/owner-registration/owner-registration-success/follow-public'),
},
{
  path: '/im',
  name: 'im',
  meta: { title: '', label: 'IM（旧版）' },
  component: () => import(/* webpackChunkName: "im" */ '@/pages/super-im-v2/index'),
},
{
  path: '/super-im',
  name: 'super-im',
  meta: { title: '', label: 'IM（新版）' },
  component: () => import(/* webpackChunkName: "super-im-v2" */ '@/pages/super-im-v2/index'),
},
{
  path: '/super-im-v2',
  name: 'super-im-v2',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "super-im-v2" */ '@/pages/super-im-v2/index'),
},
{
  path: '/reward-for-driver',
  name: 'reward-for-driver',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "transfer" */ '@/pages/reward-to-driver/index'),
},
{
  path: '/driver-reward-center',
  name: 'driver-reward-center',
  meta: { title: '奖励中心', label: '奖励中心' },
  component: () => import(/* webpackChunkName: "driver-reward-center" */ '@/pages/driver-reward-center/index'),
},
{
  path: '/transfer',
  name: 'transfer',
  meta: { title: '添加费用', label: '添加费用' },
  component: () => import(/* webpackChunkName: "transfer" */ '@/pages/transfer/index'),
},
{
  path: '/transfer/detail',
  meta: { title: '转账明细', label: '转账明细' },
  name: 'transfer-detail',
  component: () => import(/* webpackChunkName: "transfer" */ '@/pages/transfer/Detail'),
},
{
  path: '/safe-place',
  name: 'safe-place',
  meta: { title: '实时位置保护', label: '实时位置保护' },
  component: () => import(/* webpackChunkName: "safe-place" */ '@/pages/safe-center/safe-place'),
},
{
  path: '/safe-secret',
  name: 'safe-secret',
  meta: { title: '隐私号码保护', label: '隐私号码保护' },
  component: () => import(/* webpackChunkName: "safe-secret" */ '@/pages/safe-center/safe-secret'),
},
{
  path: '/safe-care',
  name: 'safe-care',
  meta: { title: '哈啰安心宝', label: '哈啰安心宝' },
  component: () => import(/* webpackChunkName: "safe-care" */ '@/pages/safe-center/safe-care'),
},
{
  path: '/xinyongchengche',
  name: 'xinyongchengche',
  meta: { title: '信用乘车', pageId: 'taxi_credit_pay_open', label: '信用乘车' },
  component: () => import(/* webpackChunkName: "xinyongchengche" */ '@/pages/xinyongchengche/index'),
},
{
  path: '/insurance',
  name: 'insurance',
  meta: { title: '顺风车保险', label: '顺风车保险' },
  component: () => import(/* webpackChunkName: "insurance" */ '@/pages/insurance/index'),
},
{
  path: '/insurance/detail',
  name: 'insurance/detail',
  meta: { title: '保单详情', label: '保单详情' },
  component: () => import(/* webpackChunkName: "insurance" */ '@/pages/insurance/Detail'),
},
{
  path: '/advanced-complain',
  name: 'advanced-complain',
  meta: { title: '投诉', keepAlive: true, label: '投诉页面' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/advanced-complain/index'),
}, {
  path: '/advanced-complain-add',
  name: 'advanced-complain-add',
  meta: { title: '投诉', label: '投诉添加' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/advanced-complain/add'),
}, {
  path: '/advanced-complain-detail',
  name: 'advanced-complain-detail',
  meta: { title: '投诉', label: '投诉详情' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/advanced-complain/detail'),
},
{
  path: '/advanced-complain/expires',
  name: 'advanced-complain/expires',
  meta: { title: '投诉', label: '投诉过期' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/advanced-complain/expires'),
},
{
  path: '/advanced-complain/expires/question',
  name: 'advanced-complain/expires/question',
  meta: { title: '常见问题', label: '常见问题' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/advanced-complain/expires-question'),
},
{
  path: '/price-difference/todo',
  name: 'price-difference/todo',
  meta: { label: '价格差异' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/price-difference/todo'),
},
{
  path: '/price-difference/process',
  name: 'price-difference/process',
  meta: { title: '车主额外拼人', label: '车主额外拼人' },
  component: () => import(/* webpackChunkName: "advanced-complain" */ '@/pages/price-difference/process'),
},
{
  path: '/xinrenfen',
  name: 'xinrenfen',
  meta: { title: '我的信任分', label: '我的信任分' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/index'),
},
{
  path: '/xinrenfen/detail',
  name: 'xinrenfen-detail',
  meta: { title: '信任分值与权益', label: '信任分值与权益' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/detail'),
},
{
  path: '/xinrenfen/deduction-list',
  name: 'xinrenfen-deduction-list',
  meta: { title: '申请免除减分项', label: '申请免除减分项' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/deductionList'),
},
{
  path: '/xinrenfen/appeal-list',
  name: 'xinrenfen-appeal-list',
  meta: { title: '申请记录', label: '申请记录' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/appealList'),
},
{
  path: '/xinrenfen/apply-reason',
  name: 'xinrenfen-apply-reason',
  meta: { title: '选择申请原因', label: '选择申请原因' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/applyReason'),
},
{
  path: '/xinrenfen/application-resolve',
  name: 'xinrenfen-application-resolve',
  meta: { title: '处理免除', label: '处理免除' },
  component: () => import(/* webpackChunkName: "xinrenfen" */ '@/pages/xinrenfen/applicationResolve'),
},
{
  path: '/find-car-or-people',
  name: 'find-car-or-people',
  meta: { title: '哈啰顺风车', label: '找车找人' },
  component: () => import(/* webpackChunkName: "find-car-or-people" */ '@/pages/find-car-or-people/index'),
},
{
  path: '/hitch-price-detail',
  name: 'hitch-price-detail',
  meta: { title: '哈啰顺风车', label: '顺风车价格详情' },
  component: () => import(/* webpackChunkName: "hitch-price-detail" */ '@/pages/hitch-price-detail/index'),
},
{
  path: '/price-detail/valuation',
  name: 'valuation',
  meta: { title: '哈啰顺风车', label: '聚合价格详情' },
  component: () => import(/* webpackChunkName: "price-detail-valuation" */ '@/pages/price-detail/valuation'),
},
{
  path: '/price-detail/pack-valuation',
  name: 'pack-valuation',
  meta: { title: '哈啰顺风车', label: '打包单价格详情' },
  component: () => import(/* webpackChunkName: "price-detail-pack-valuation" */ '@/pages/price-detail/pack-valuation'),
},

{
  path: '/hitch-pax-price-detail',
  name: 'hitch-pax-price-detail',
  meta: { title: '哈啰顺风车', label: '顺风车乘客价格详情' },
  component: () => import(/* webpackChunkName: "hitch-pax-price-detail" */ '@/pages/hitch-price-detail/index'),
},
{
  path: '/hitch-pax-pre-price-detail',
  name: 'hitch-pax-pre-price-detail',
  meta: { title: '哈啰顺风车', label: '顺风车乘客预付价格详情' },
  component: () => import(/* webpackChunkName: "hitch-pax-pre-price-detail" */ '@/pages/hitch-pax-pre-price-detail/index'),
},
{
  path: '/service-notification',
  name: 'service-notification',
  meta: { title: '开通服务号', label: '开通服务号' },
  component: () => import(/* webpackChunkName: "service-notification" */ '@/pages/service-notification/index'),
},
{
  path: '/real-name-auth/pax',
  name: 'real-name-auth/pax',
  meta: { title: '实名认证', label: '实名认证（旧版）' },
  component: () => import(/* webpackChunkName: "real-name-auth" */ '@/pages/real-name-auth/PaxRealNameAuth'),
},
{
  path: '/real-name-auth/v2',
  name: 'real-name-auth/v2',
  meta: { title: '实名认证', label: '实名认证（新版）' },
  component: () => import(/* webpackChunkName: "real-name-auth" */ '@/pages/real-name-auth/index'),
},
{
  path: '/invite-guide',
  name: 'invite-guide',
  meta: { title: '新手引导', label: '新手引导' },
  component: () => import(/* webpackChunkName: "invite-guide" */ '@/pages/invite-guide/Index'),
},
{
  path: '/hitch-journey-share',
  name: 'hitch-journey-share',
  meta: { title: '行程分享', pageId: 'hitch_journey_share', label: '行程分享' },
  component: () => import(/* webpackChunkName: "hitch-journey-share" */ '@/pages/hitch-journey-share/index'),
},
{
  path: '/pay-sign-center',
  name: 'pay-sign-center',
  meta: { title: '预付优先接', label: '预付优先接' },
  component: () => import(/* webpackChunkName: "pay-sign-center" */ '@/pages/pay-sign-center/index'),
},
{
  path: '/black-list',
  name: 'black-list',
  meta: { title: '黑名单', label: '黑名单' },
  component: () => import(/* webpackChunkName: "black-list" */ '@/pages/black-list/index'),
},
{
  path: '/setup',
  name: 'setup',
  meta: { title: '设置', keepAlive: true, label: '设置' },
  component: () => import(/* webpackChunkName: "setup" */ '@/pages/setup/index'),
},
{
  path: '/withdrawal',
  name: 'withdrawal',
  meta: { title: '提现', label: '提现' },
  component: () => import(/* webpackChunkName: "withdrawal" */ '@/pages/withdrawal/index'),
},
{
  path: '/business-cashback',
  name: 'business-cashback',
  meta: { title: '', label: '商旅返现' },
  component: () => import(/* webpackChunkName: "business-cashback" */ '@/pages/business-cashback/Index'),
},
{
  path: '/your-details',
  name: 'your-details',
  meta: { title: '个人中心', keepAlive: true, label: '个人中心（旧版）' },
  component: () => import(/* webpackChunkName: "your-details" */ '@/pages/homepage/your-details-v2'),
},
{
  path: '/your-details-v2',
  name: 'your-details-v2',
  meta: { title: '个人中心', keepAlive: true, label: '个人中心（新版）' },
  component: () => import(/* webpackChunkName: "your-details-v2" */ '@/pages/homepage/your-details-v2'),
},
{
  path: '/view-details',
  name: 'view-details',
  meta: { title: 'TA的主页', keepAlive: true, label: 'TA的主页' },
  component: () => import(/* webpackChunkName: "view-details" */ '@/pages/homepage/view-details'),
},
{
  path: '/view-pax-details',
  name: 'view-pax-details',
  meta: { title: 'TA的主页', keepAlive: true, label: 'TA的主页（乘客）' },
  component: () => import(/* webpackChunkName: "view-details" */ '@/pages/homepage/view-details'),
},
{
  path: '/edit-info',
  name: 'edit-info',
  meta: { title: '编辑个人资料', label: '编辑个人资料' },
  component: () => import(/* webpackChunkName: "edit-info" */ '@/pages/homepage/edit-info'),
},
{
  path: '/edit-name',
  name: 'edit-name',
  meta: { title: '修改昵称', label: '修改昵称' },
  component: () => import(/* webpackChunkName: "edit-info" */ '@/pages/homepage/edit-name'),
},
{
  path: '/car-picture',
  name: 'car-picture',
  meta: { title: '车辆照片', label: '车辆照片' },
  component: () => import(/* webpackChunkName: "car-picture" */ '@/pages/homepage/picture'),
},
{
  path: '/pre-certification-activity/:activityId/:channelId',
  name: 'pre-certification-activity',
  meta: { title: '哈啰顺风车车主招募', label: '车主招募' },
  component: () => import(/* webpackChunkName: "outside-pre-certification" */ '@/pages/pre-certification-activity/index'),
},
{
  path: '/outside-pre-certification',
  meta: { title: '车主预认证' },
  component: () => import(/* webpackChunkName: "outside-pre-certification" */ '@/pages/outside-pre-certification/index'),
  children: [{
    path: 'form/:activityId/:channelId',
    name: 'outside-pre-certification-form',
    component: () => import(/* webpackChunkName: "outside-pre-certification" */ '@/pages/outside-pre-certification/form/index'),
  },
  {
    path: 'result/:activityId/:channelId',
    name: 'outside-pre-certification-result',
    component: () => import(/* webpackChunkName: "outside-pre-certification" */ '@/pages/outside-pre-certification/result/index'),
  },
  {
    path: 'status/:activityId/:channelId',
    name: 'outside-pre-certification-status',
    component: () => import(/* webpackChunkName: "outside-pre-certification" */ '@/pages/outside-pre-certification/status/index'),
  },
  {
    path: '',
    redirect: '/outside-pre-certification/form',
  },
  ],
},
{
  path: '/valuation-rule',
  name: 'valuation-rule',
  meta: { label: '计价规则' },
  component: () => import(/* webpackChunkName: "valuation-rule" */ '@/pages/valuation-rule/Index'),
},
{
  path: '/pos-report-rules',
  name: 'pos-report-rules',
  component: () => import(/* webpackChunkName: "pos-report-rules" */ '@/pages/pos-report-rules/index'),
},
{
  path: '/why-cancel-forward',
  name: 'why-cancel-forward',
  meta: { title: '取消行程' },
  component: () => import(/* webpackChunkName: "why-cancel-forward" */ '@/pages/why-cancel/why-cancel-forward'),
},
{
  path: '/why-cancel',
  name: 'why-cancel',
  meta: { title: '取消行程' },
  component: () => import(/* webpackChunkName: "why-cancel" */ '@/pages/why-cancel/index'),
},
{
  path: '/cancel-order-new',
  name: 'cancel-order-new',
  meta: { title: '取消行程' },
  component: () => import(/* webpackChunkName: "cancel-order-new" */ '@/pages/cancel-order-new/index'),
},
{
  path: '/cancel-order-before-confirm',
  name: 'cancel-order-before-confirm',
  meta: { title: '取消行程' },
  component: () => import(/* webpackChunkName: "cancel-order-new" */ '@/pages/cancel-order-before-confirm/index'),
},
{
  path: '/retention',
  name: 'retention',
  meta: { title: ' ' },
  component: () => import(/* webpackChunkName: "retention" */ '@/pages/retention/index'),
},
{
  path: '/cancel-add-value-fee',
  name: 'cancel-add-value-fee',
  meta: { title: '取消行程' },
  component: () => import(/* webpackChunkName: "cancel-add-value-fee" */ '@/pages/cancel-add-value-fee/index'),
},
{
  path: '/evaluation',
  name: 'evaluation',
  meta: { title: '客服满意度（人工）', label: '客服满意度（人工）' },
  component: () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/index'),
},
{
  path: '/car-inconformity',
  name: 'car-inconformity',
  meta: { title: ' ' },
  component: () => import(/* webpackChunkName: "car-inconformity" */ '@/pages/car-inconformity/index'),
},
{
  path: '/car-inconformity-result',
  name: 'car-inconformity-result',
  meta: { title: ' ' },
  component: () => import(/* webpackChunkName: "car-inconformity" */ '@/pages/car-inconformity/result'),
},
{
  path: '/lost-items',
  meta: { title: '' },
  name: 'lost-items',
  component: () => import(/* webpackChunkName: "lost-items" */ '@/pages/lost-items/index'),
},
{
  path: '/safety-test',
  meta: { title: '安全知识测试' },
  name: 'safety-test',
  component: () => import(/* webpackChunkName: "safety-test" */ '@/pages/safety-test/index'),
},
{
  path: '/safety-test-result',
  meta: { title: '安全知识测试' },
  name: 'safety-test-result',
  component: () => import(/* webpackChunkName: "safety-test" */ '@/pages/safety-test/result'),
},
{
  path: '/im-conversation-list',
  meta: { title: '' },
  name: 'im-conversation-list',
  component: () => import(/* webpackChunkName: "im-conversation-list-v2" */ '@/pages/im-conversation-list-v2/index'),
},
{
  path: '/im-conversation-list-v2',
  meta: { title: '' },
  name: 'im-conversation-list-v2',
  component: () => import(/* webpackChunkName: "im-conversation-list-v2" */ '@/pages/im-conversation-list-v2/index'),
},
{
  path: '/user-ban',
  name: 'user-ban',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/user-ban'),
},
{
  path: '/new-comment',
  name: 'new-comment',
  meta: { title: '评价' },
  component: () => import(/* webpackChunkName: "new-comment" */ '@/pages/homepage/new-comment'),
},
{
  path: '/my-vehicles',
  name: 'myVehicles',
  meta: { title: '我的爱车' },
  component: () => import(/* webpackChunkName: "my-vehicles" */ '@/pages/my-vehicles'),
},
{
  path: '/jump-to-wechatmp',
  name: 'jump-to-wechatmp',
  meta: { title: '哈啰顺风车' },
  component: () => import(/* webpackChunkName: "jump-to-wechatmp" */ '@/pages/JumpToWechatmp/index'),
},
{
  path: '/driver-finish-order-rate',
  name: 'driverFinishOrderRate',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "driver-finish-order-rate" */ '@/pages/driver-finish-order-rate'),
},
{
  path: '/driver-finish-order-rate-history',
  name: 'driverFinishOrderRateHistory',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "driver-finish-order-rate-history" */ '@/pages/driver-finish-order-rate-history'),
},
{
  path: '/health-statement',
  name: 'healthStatement',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/health-statement'),
},
{
  path: '/driver-match-list',
  name: 'driverMatchList',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/driver-match-list'),
},
{
  path: '/cancle-responsibility',
  name: 'cancleResponsibility',
  meta: { title: '联系不上乘客/车主' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/contact-failed-cancle-without-responsibility'),
},
{
  path: '/driver-login',
  name: 'driverLogin',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/driver-login'),
},
{
  path: '/wx-follow',
  name: 'wxFollow',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/wx-follow'),
},
{
  path: '/wx-follow-new',
  name: 'wx-follow-new',
  meta: { title: '' },
  component: () => import(/* webpackChunkName: "health-statement" */ '@/pages/wx-follow-new'),
},
// 车主成长体系
{
  path: '/driver-growth-system-detail',
  name: 'driver-growth-system-detail',
  meta: { title: '成长等级', keepAlive: true, label: '成长等级' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/detail'),
},
{
  path: '/driver-growth-system-score',
  name: 'driver-growth-system-score',
  meta: { title: '评分', label: '评分' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/score'),
},
{
  path: '/driver-growth-system-rights',
  name: 'driver-growth-system-rights',
  meta: { title: '我的权益', label: '我的权益' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/rights'),
},
{
  path: '/driver-growth-system-task',
  name: 'driver-growth-system-task',
  meta: { title: '全部任务', label: '全部任务' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/task'),
},
{
  path: '/driver-growth-system-statement',
  name: 'driver-growth-system-statement',
  meta: { title: '我的成长值', label: '我的成长值' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/statement'),
},
{
  path: '/violation-handle',
  name: 'violation-handle',
  meta: { title: '违规处理', label: '违规处理' },
  component: () => import(/* webpackChunkName: "violation-handle" */ '@/pages/violation-handle'),
},
{
  path: '/public-downLoad',
  name: 'public-downLoad',
  meta: { title: '通用下载页', label: '通用下载页' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/public-downLoad/index'),
},
{
  path: '/recognizance',
  name: 'recognizance',
  meta: { title: '保证金', label: '保证金' },
  component: () => import(/* webpackChunkName: "recognizance" */ '@/pages/recognizance/index'),
},
{
  path: '/recognizance-detail',
  name: 'recognizance-detail',
  meta: { title: '保证金明细', label: '保证金明细' },
  component: () => import(/* webpackChunkName: "recognizance" */ '@/pages/recognizance/detail'),
},
{
  path: '/online-complain-submit',
  name: 'online-complain-submit',
  meta: { title: '投诉反馈', label: '投诉反馈' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/passenger/submit'),
},
{
  path: '/online-complain-progress-rate',
  name: 'online-complain-progress-rate',
  meta: { title: '投诉进度', label: '投诉进度' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/passenger/progress-rate'),
},
{
  path: '/online-complain-history',
  name: 'online-complain-history',
  meta: { title: '投诉记录', label: '投诉记录' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/passenger/history'),
},
{
  path: '/passenger-online-complain-submit',
  name: 'passenger-online-complain-submit',
  meta: { title: '申诉' },
  component: () => import(/* webpackChunkName: "passenger-online-complain-submit" */ '@/pages/online-complain/passenger/appeal/submit'),
},
{
  path: '/passenger-online-complain-progress-rate',
  name: 'passenger-online-complain-progress-rate',
  meta: { title: '申诉进度' },
  component: () => import(/* webpackChunkName: "passenger-online-complain-progress-rate" */ '@/pages/online-complain/passenger/appeal/progress-rate'),
},
{
  path: '/driver-growth-system/behavior-score/index',
  name: 'driver-growth-system/behavior-score/index',
  meta: { title: '行为分', label: '行为分' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/behavior-score/index'),
},
{
  path: '/driver-growth-system/behavior-score/detail',
  name: 'driver-growth-system/behavior-score/detail',
  meta: { title: '权益详情', label: '权益详情' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/behavior-score/detail'),
},
{
  path: '/driver-growth-system/history-records',
  name: 'driver-growth-system/history-records',
  meta: { title: '历史记录', label: '历史记录' },
  component: () => import(/* webpackChunkName: "driver-growth-system" */ '@/pages/driver-growth-system/history-records'),
},
{
  path: '/toll-charge',
  name: 'toll-charge',
  meta: { title: '', label: '过路费' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/toll-charge/index'),
},
{
  path: '/route',
  name: 'route',
  meta: { label: '常用路线' },
  component: loadRouteComponent('route/app'),
  children: [{
    path: '/route/manage',
    name: 'route-manage',
    meta: { label: '常用路线-管理页' },
    component: loadRouteComponent('route/manage'),
  }, {
    path: '/route/update',
    name: 'route-update',
    meta: { label: '常用路线-编辑页' },
    component: loadRouteComponent('route/update'),
  }, {
    path: '/route/order-list',
    name: 'route-order-list',
    meta: { label: '常用路线-找单列表页' },
    component: loadRouteComponent('route/order-list'),
  }, {
    path: '/route/history-order-list',
    name: 'route-history-order-list',
    meta: { label: '历史订单' },
    component: loadRouteComponent('route/history-order-list'),
  }],
},
{
  path: '/driver-online-complain-progress-rate',
  name: 'driver-online-complain-progress-rate',
  meta: { title: '申诉进度', label: '申诉进度' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/driver/appeal/progress-rate'),
},
// {
//   path: '/driver-online-complain-history',
//   name: 'driver-online-complain-history',
//   meta: { title: '申诉记录' },
//   component: () => import(/* webpackChunkName: "online-complain" */
//     '@/pages/online-complain/driver/history'
//   ),
// },
{
  path: '/driver-online-complain-submit',
  name: 'driver-online-complain-submit',
  meta: { title: '申诉', label: '申诉' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/driver/appeal/submit'),
},
{
  path: '/driver-complain-submit',
  name: 'driver-complain-submit',
  meta: { title: '提交反馈', label: '提交反馈' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/driver/complain/submit'),
},
{
  path: '/driver-complain-progress-rate',
  name: 'driver-complain-progress-rate',
  meta: { title: '投诉进度', label: '投诉进度' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/online-complain/driver/complain/progress-rate'),
},
{
  path: '/manage-passenger-pk',
  name: 'manage-passenger-pk',
  meta: { title: '', label: 'PK乘客预期管理页' },
  component: () => import(/* webpackChunkName: "manage-passenger-pk" */ '@/pages/manage-passenger-pk/index.vue'),
},
{
  path: '/driver-free-pk',
  name: 'driver-free-pk',
  meta: { title: '免PK卡', label: '免PK卡' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/driver-free-pk/index'),
},
{
  path: '/jump',
  name: 'jump',
  meta: { title: '跳转微信小程序', label: '跳转微信小程序' },
  component: () => import(/* webpackChunkName: "online-complain" */ '@/pages/jump/weapp.vue'),
},
{
  path: '/upload-avatar',
  name: 'upload-avatar',
  meta: { title: ' ', label: '头像上传页' },
  component: () => import(/* webpackChunkName: "upload-avatar" */ '@/pages/homepage/upload-avatar.vue'),
},
{
  path: '/price-guarantee',
  name: 'price-guarantee',
  meta: { title: '贵必赔信息采集', label: '贵必赔信息采集' },
  component: () => import(/* webpackChunkName: "price-guarantee" */ '@/pages/price-guarantee/index'),
},
{
  path: '/alternate-order-list',
  name: 'alternate-order-list',
  meta: { title: '候补订单', label: '候补订单列表' },
  component: () => import(/* webpackChunkName: "alternate-order-list" */ '@/pages/alternate-order-list/index'),
},
];

// 非生产页面
if (process.env.VUE_APP_ENV !== 'pro') {
  routes.push(
    {
      path: '/',
      redirect: '/mock-index',
    },
    {
      path: '/mock-index',
      name: 'MockIndex',
      meta: { title: '测试页面' },
      component: () => import(/* webpackChunkName: "mock" */ '@/pages/mock-index/index'),
    },
    {
      path: '/test-tool/miniprogram-jump-test',
      name: 'miniprogram-jump-test',
      meta: { title: '小程序跳转测试工具', label: '小程序跳转测试工具' },
      component: () => import(/* webpackChunkName: "test-tool" */ '@/pages/test-tool/miniprogram-jump-test.vue'),
    },
  );
}

export default routes;
